import { render } from "./time-tracker.vue?vue&type=template&id=20bd1686&scoped=true"
import script from "./time-tracker.vue?vue&type=script&lang=js"
export * from "./time-tracker.vue?vue&type=script&lang=js"

import "./time-tracker.vue?vue&type=style&index=0&id=20bd1686&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bd1686"]])

export default __exports__